import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateStorageService {
  constructor() {}

  updateLanguageKey(lang: string): void {
    sessionStorage.setItem('language', lang);
  }

  getLanguageKey(): string | null {
    return sessionStorage.getItem('language');
  }
}
